var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { attrs: { md: "6" } },
        [
          _c(
            "card",
            { staticClass: "stacked-form" },
            [
              _vm.isLoading
                ? _c("l-progress", {
                    staticClass: "mb-2",
                    attrs: {
                      value: 100,
                      height: 20,
                      type: "info",
                      animated: true,
                      striped: true
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-6" }, [
                  _c(
                    "div",
                    [
                      _c("fg-input", { attrs: { label: "Name" } }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.model.name !== null ? _vm.model.name : "-"
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("fg-input", { attrs: { label: "Email" } }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.model.email !== null ? _vm.model.email : "-"
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "fg-input",
                        { attrs: { label: "Dibuat pada tanggal" } },
                        [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.model.createdAt !== null
                                  ? _vm.model.createdAt
                                  : "-"
                              )
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("fg-input", { attrs: { label: "Active" } }, [
                        _c(
                          "p",
                          [
                            _c("l-switch", {
                              attrs: {
                                width: 30,
                                type: "primary",
                                "active-value": 1,
                                "inactive-value": 0
                              },
                              on: {
                                change: function($event) {
                                  _vm.changeSwitch(
                                    "isActive",
                                    "Available",
                                    _vm.model.isActive
                                  )
                                }
                              },
                              model: {
                                value: _vm.model.isActive,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "isActive", $$v)
                                },
                                expression: "model.isActive"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.role === "owner" ? _c("edit-button") : _vm._e(),
              _vm._v(" "),
              _c("back-button")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a36021a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a36021a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Pages/Settings/Users/Cashiers/Show.vue
// module id = TGOv
// module chunks = 4